module.exports = __webpack_public_path__ + "static/media/NewBanos_v2.4277cc02.png";